module.exports = __webpack_public_path__ + "img/illust-08.33a35913.png";